import { alpha, Box, Chip, styled } from "@mui/material";

export const VersionNameBadge = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius * 0.5,
  padding: theme.spacing(0.25, 0.75),
  fontSize: "0.75rem",
  fontFamily: "monospace",
}));

export const CostDeltaChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "isIncrease",
})<{ isIncrease: boolean }>(({ theme, isIncrease }) => ({
  height: 20,
  fontSize: "0.7rem",
  fontWeight: 700,
  backgroundColor: alpha(isIncrease ? theme.palette.error.main : theme.palette.success.main, 0.2),
  color: isIncrease ? theme.palette.error.dark : theme.palette.success.dark,
  "& .MuiChip-icon": {
    color: "inherit",
    fontSize: "0.85rem",
    marginLeft: 6,
  },
  "& .MuiChip-label": {
    padding: "0 6px",
  },
}));
